module.exports = __webpack_public_path__ + "img/vision_background.d7cc90e3.png";